import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { NutrientBalanceTable } from '../../models';

@Component({
  selector: 'app-nutrient-balance-table',
  templateUrl: './nutrient-balance-table.component.html',
  styleUrls: ['./nutrient-balance-table.component.scss'],
  standalone: false,
})
export class NutrientBalanceTableComponent {
  @Input() tableReportData$: Observable<NutrientBalanceTable[]>;
  displayedColumns = ['element', 'supply', 'drainage', 'balance'];
}
